var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientEditButton = function SvgPatientEditButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A657B",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.656 5.222c-.1.102-.188.229-.238.356l-.854 1.916c-.137.355.151.646.49.495l1.896-.85c.125-.063.25-.14.351-.241l4.645-4.606a1.181 1.181 0 0 0 0-1.675 1.151 1.151 0 0 0-1.657 0L4.656 5.222z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 6.052c-.447 0-.857.355-.857.795v2.445c0 .44-.252.843-.7.843H2.273c-.447 0-.559-.403-.559-.843v-7.22c0-.44.112-.383.56-.383h2.379c.447 0 .808-.403.808-.844C5.46.405 5.1 0 4.653 0h-2.38C.946 0 0 .764 0 2.072v7.22c0 1.308.946 2.533 2.273 2.533h7.328C10.928 11.825 12 10.6 12 9.292V6.847c0-.44-.41-.795-.857-.795"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientEditButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-edit-button.ae5323da295957792d5e93ff8caf361d.svg";